import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import "./preEnrolmentInfo.css";

import { NoData } from "../no-data/NoData";
import { UpdatePreEnrolment } from "./UpdatePreEnrolment";
import { toggleModelBox } from "../../systemSlice";
import { useNavigate, useParams } from "react-router-dom"; // updated
import { deletePreEnrolAction } from "../../pages/pre-enrolment/preEnrolmentAction";

const PreEnrolmentInfo = () => {
  const dispatch = useDispatch();
  const { _id } = useParams();
  const navigate = useNavigate(); // updated
  const { user } = useSelector((state) => state.user);
  const { preEnrolments } = useSelector((state) => state.preEnrol);

  const preEnrolment = preEnrolments.find((pre) => pre._id === _id);

  if (!preEnrolment?._id) {
    return <NoData />;
  }

  const updateEnrolment = () => {
    dispatch(toggleModelBox());
  };

  const delPreEnrolment = () => {
    if (window.confirm("Are you sure you want to delete this pre-enrolment?")) {
      dispatch(deletePreEnrolAction(_id, user?.branch));
      navigate("/pre-enrolment"); // navigate after deletion
    }
  };

  return (
    <Container>
      <UpdatePreEnrolment title="Update Enrolment" show={true} />

      <Row className="courseInfo mt-3">
        <h4 className="enrolInfo d-flex justify-content-between text-primary">
          <span>Pre-Enrolment Info</span>
          {user?.role === "admin" && (
            <span className="edit" onClick={updateEnrolment}>
              <i className="fas fa-edit"></i>
            </span>
          )}
        </h4>
        <hr />

        <Col md="6">
          <div>
            <b>
              <u>Student:</u>
            </b>
            <h6>
              First Name: <b>{preEnrolment?.fName}</b>
            </h6>
            <h6>
              Last Name: <b>{preEnrolment?.lName}</b>
            </h6>
            <h6>
              Mobile: <b>{preEnrolment?.mobile}</b>
            </h6>
            <h6>
              Email: <b>{preEnrolment?.email}</b>
            </h6>
          </div>

          <div className="mt-3">
            <h6>
              <b>
                <u>Course:</u>
              </b>
              <br />
              Title: <b>{preEnrolment?.course?.name}</b>
              <br />
              Code: <b>{preEnrolment?.course?.courseCode}</b>
            </h6>

            <h6 className="mt-2">
              <b>
                <u>Duration:</u>
              </b>
              <br />
              <b>
                {new Date(
                  preEnrolment?.course?.commenceDate
                ).toLocaleDateString()}{" "}
                - {new Date(preEnrolment?.course?.endDate).toLocaleDateString()}
              </b>
            </h6>
          </div>
        </Col>

        <Col
          md="6"
          className="d-flex flex-column justify-content-between align-items-baseline"
        >
          <div>
            <h6>
              Location: <b>Dented Code Academy, Rockdale</b>
            </h6>
            <h6>
              Full Fee: <b>${preEnrolment.fees?.originalFee}</b>
            </h6>
            <h6>
              Payment status:{" "}
              <b style={{ color: "red", letterSpacing: "1px" }}>
                {preEnrolment.payment?.status.toUpperCase()}
              </b>
            </h6>
          </div>

          <button
            className="btn btn-danger mt-3"
            style={{ letterSpacing: "3px", fontSize: "20px" }}
            onClick={delPreEnrolment}
          >
            Cancel Enrolment
          </button>
        </Col>

        <Col md={12} className="mt-5">
          <div className="border p-4 rounded-4 d-flex flex-column gap-2">
            <div>
              <b>What are your 3 main goals of taking this program?</b>
              <p>{preEnrolment?.goals}</p>
            </div>
            <div>
              <b>
                What are your 3 biggest challenges getting into the tech
                industry?
              </b>
              <p>{preEnrolment?.challenges}</p>
            </div>
            <div>
              <b>How this program can help you to reach your goals?</b>
              <p>{preEnrolment?.howReachGoal}</p>
            </div>
            <div>
              <b>Where did you hear about us?</b>
              <p>{preEnrolment?.whereFrom}</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PreEnrolmentInfo;
